export default {
  allPermissions: [],
  permission: {},
}
